<template>
  <footer class="footer mt-auto py-3">
    <div class="container text-center">
      <span class="">© S2H Groupe 2022. Tous droits réservés.</span>
      <a
        class="mx-2"
        target="_blank"
        href="https://www.vivinter.fr/fr/mentions-legales-options.html"
        >Mentions légales</a
      >
    </div>
  </footer>
</template>

<style lang="scss" scoped></style>
